module.exports = __webpack_public_path__ + "static/media/wechatQR.35cc01d3.png";


//////////////////
// WEBPACK FOOTER
// ./src/component/footer/images/wechatQR.png
// module id = 369
// module chunks = 4